import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Award, DollarSign, Globe, Share2, CheckCircle } from 'lucide-react';
import '../styles/Ambassadors.css';

const Ambassadors = () => {
  return (
    <div className="ambassadors-container">
      <section className="ambassadors-hero">
        <h1>Become a Falphin Ambassador</h1>
        <p>
          Join our exclusive program and earn rewards by spreading the word about Falphin. 
          As an ambassador, you'll get access to exclusive perks, early features, and 
          commission on every artist you bring to our platform.
        </p>
        <a href="#join" className="cta-button">Join the Program</a>
      </section>

      <section>
        <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>Why Become an Ambassador?</h2>
        <div className="benefits-grid">
          <div className="benefit-card">
            <h3><DollarSign size={24} /> Earn Commissions</h3>
            <p>Get paid for every artist who signs up through your unique referral link. The more artists you bring, the more you earn.</p>
          </div>
          
          <div className="benefit-card">
            <h3><Award size={24} /> Exclusive Perks</h3>
            <p>Gain access to special features, early product releases, and exclusive ambassador-only events and content.</p>
          </div>
          
          <div className="benefit-card">
            <h3><Globe size={24} /> Build Your Network</h3>
            <p>Connect with other music industry professionals and grow your network within the Falphin community.</p>
          </div>
          
          <div className="benefit-card">
            <h3><Share2 size={24} /> Share Your Passion</h3>
            <p>Help independent artists succeed by introducing them to the tools they need to grow their careers.</p>
          </div>
        </div>
      </section>

      <section className="cta-section" id="join">
        <h2>Ready to Get Started?</h2>
        <p>Join our ambassador program today and start earning while helping artists succeed.</p>
        <Link to="/contact" className="cta-button">Become an Ambassador</Link>
      </section>

      <section style={{ maxWidth: '800px', margin: '4rem auto', textAlign: 'center' }}>
        <h3>How It Works</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', marginTop: '2rem', textAlign: 'left' }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
            <div style={{ flexShrink: 0, color: 'var(--accent-primary)' }}><CheckCircle size={24} /></div>
            <div>
              <h4>Sign Up</h4>
              <p>Fill out our ambassador application form and get approved within 48 hours.</p>
            </div>
          </div>
          
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
            <div style={{ flexShrink: 0, color: 'var(--accent-primary)' }}><CheckCircle size={24} /></div>
            <div>
              <h4>Get Your Unique Link</h4>
              <p>Receive your personal referral link to share with artists and music professionals.</p>
            </div>
          </div>
          
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
            <div style={{ flexShrink: 0, color: 'var(--accent-primary)' }}><CheckCircle size={24} /></div>
            <div>
              <h4>Start Earning</h4>
              <p>Earn commissions for every artist who signs up through your link and starts using Falphin's services.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Ambassadors;
